// Generated by tools/capture-studio-preview.mjs from the current Studio UI.
export const STUDIO_PREVIEW = {
  "width": 1440,
  "height": 900,
  "focus": {
    "studio-flow": {
      "left": 12.222222222222221,
      "top": 1.1267361111111112,
      "width": 12.643229166666666,
      "height": 4
    },
    "studio-trigger": {
      "left": 74.16666666666667,
      "top": 12.973958333333334,
      "width": 25.833333333333332,
      "height": 87.02604166666667
    },
    "studio-screenplay": {
      "left": 22.84722222222222,
      "top": 12.973958333333334,
      "width": 50.97222222222222,
      "height": 87.02604166666667
    },
    "studio-sharing": {
      "left": 26.38888888888889,
      "top": 14.109375,
      "width": 47.22222222222222,
      "height": 71.77951388888889
    }
  }
} as const;
